<template>
  <bottom-bar-layout v-if="loaded"
                     class="page-children-day"
                     show-bar
                     :bar-height="150"
                     :shadow="false"
  >
    <ym-img class="page-children-day-header"
            :src="require('@/pages/2021/ChildrenDay/assets/img/header_bg.png')"
    />
    <div class="page-children-day-draw"
         v-ym-report:MARKETING_2021CHILDRENDAY_LOTTERY_EXPOSURE=""
    >
      <div class="page-children-day-draw-top">
        <div class="item"
             @click="showRule = true"
        >
          活动规则
        </div>
        <div class="item"
             @click="handlePrize"
        >
          我的盲盒
        </div>
      </div>
      <div class="page-children-day-draw-box"
           @click="handleDraw"
      ></div>
      <div class="page-children-day-draw-list"
           ref="container"
      >
        <div v-for="(item, index) in prizeList"
             :key="index"
             class="item"
             @click="handleClickPrize(item)"
             v-ym-report:MARKETING_2021CHILDRENDAY_LOTTERY_PRIZE_CLICK="{ title: item.title }"
        >
          <ym-img class="cover"
                  :src="item.cover"
          />
          <div class="text">查看奖品</div>
        </div>
      </div>
      <div class="page-children-day-draw-btn">
        <div class="page-children-day-draw-btn-left"
             @click="handleShare"
             v-ym-report:MARKETING_2021CHILDRENDAY_LOTTERY_SHARE_CLICK=""
        >
          分享获得更多<br>开盒机会
        </div>
        <div class="page-children-day-draw-btn-center"
             :class="drawState"
             @click="handleDraw"></div>
        <div class="page-children-day-draw-btn-right">
          <div class="content">
            <div class="left">剩余<br>次数</div>
            <div class="right">{{ drawCount }}</div>
          </div>
        </div>
      </div>
      <winning-list-notice-bar class="page-children-day-draw-notice"
                               :list="winningList" />
    </div>
    <ym-img class="page-children-day-project-title"
            :src="require('@/pages/2021/ChildrenDay/assets/img/title_project.png')"
    />
    <div class="page-children-day-project-container">
      <ym-img class="page-children-day-project-container-top"
              :src="require('@/pages/2021/ChildrenDay/assets/img/project_top.png')"
      />
      <div class="page-children-day-project-list">
        <router-link v-for="(item,index) in project.list"
                     :key="index"
                     :to="item.path"
                     class="page-children-day-project-list-item"
                     v-ym-report:MARKETING_2021CHILDRENDAY_PROJECT_JOIN_CLICK="{ id: item.id }"
        >
          <ym-img class="page-children-day-project-list-item-cover"
                  :src="item.cover"
          />
          <div class="page-children-day-project-list-item-age">
            {{ item.age }}
          </div>
          <ym-img class="page-children-day-project-list-item-hot"
                  :src="require('@/pages/2021/ChildrenDay/assets/img/project_hot.png')"
          />
          <div class="page-children-day-project-list-item-title">
            {{ item.title }}
          </div>
          <div class="page-children-day-project-list-item-desc">
            {{ item.desc }}
          </div>
          <div class="page-children-day-project-list-item-bottom">
            <div class="left">最高立减<span>￥</span><span>{{ item.price }}</span></div>
            <div class="right">立即参加</div>
          </div>
        </router-link>
        <div class="page-children-day-project-list-more">
          <div class="page-children-day-project-list-more-top">
            更有<span>{{ project.moreText }}</span>等
          </div>
          <div class="page-children-day-project-list-more-bottom">
            多个研学营
          </div>
        </div>
        <router-link to="https://m.youthmba.com/marketing/common/activity/summerProject2021"
                     v-ym-report:MARKETING_2021CHILDRENDAY_PROJECT_MORE_CLICK=""
        >
          <ym-img class="page-children-day-project-list-btn"
                  :src="require('@/pages/2021/ChildrenDay/assets/img/project_btn.gif')"
          />
        </router-link>
      </div>
      <ym-img class="page-children-day-project-container-bottom"
              :src="require('@/pages/2021/ChildrenDay/assets/img/project_bottom.png')"
      />
    </div>
    <ym-img class="page-children-day-school-title"
            :src="require('@/pages/2021/ChildrenDay/assets/img/title_school.png')"
    />
    <div class="page-children-day-school-list">
      <router-link v-for="(item,index) in schoolList"
                   :key="index"
                   :to="`https://m.youthmba.com/course/${item.id}`"
                   class="page-children-day-school-list-item"
                   v-ym-report:MARKETING_2021CHILDRENDAY_COURSE_CLICK="{ id: item.id }"
      >
        <ym-img class="page-children-day-school-list-item-cover"
                :src="item.cover"
        />
      </router-link>
    </div>
    <ym-img class="page-children-day-discount-title"
            :src="require('@/pages/2021/ChildrenDay/assets/img/title_discount.png')"
    />
    <div class="page-children-day-discount-container">
      <router-link to="https://m.youthmba.com/vip/1"
                   class="page-children-day-discount-container-card"
                   v-ym-report:MARKETING_2021CHILDRENDAY_VIP_CLICK=""
      >
        <div class="page-children-day-discount-container-card-price">
          半价特惠<span>￥</span><span>499/年</span>
        </div>
      </router-link>
      <div class="page-children-day-discount-container-title">
        <div class="top">少商优选团购书籍</div>
        <div class="bottom">扩展孩子知识面</div>
      </div>
      <div class="page-children-day-discount-container-list">
        <router-link v-for="(item,index) in bookList"
                     :key="index"
                     :to="`https://m.youthmba.com/entity/${item.id}`"
                     class="page-children-day-discount-container-list-item"
                     v-ym-report:MARKETING_2021CHILDRENDAY_GROUPON_CLICK="{ id: item.id }"
        >
          <ym-img class="page-children-day-discount-container-list-item-cover"
                  :src="item.cover"
          />
        </router-link>
      </div>
      <a href="https://item.m.jd.com/product/13297754.html"
         class="page-children-day-discount-container-entity-book"
         v-ym-report:MARKETING_2021CHILDRENDAY_GROUPON_CLICK="{ type: '张老师的实体书' }"
      />
      <router-link to="https://m.youthmba.com/entity/4"
                   class="page-children-day-discount-container-calendar"
                   v-ym-report:MARKETING_2021CHILDRENDAY_GROUPON_CLICK="{ id: 4 }"
      />
    </div>
    <div class="page-children-day-rule">
      <div class="page-children-day-rule-title">
        <span>活动规则</span>
      </div>
      <div class="page-children-day-rule-list">
        <div v-for="(item, index) in activityRule"
             :key="index"
             class="page-children-day-rule-list-item">
          <span>{{ index + 1 }}.</span>
          {{ item }}
        </div>
      </div>
    </div>
    <share-mask :show.sync="showShareMask"
                ref="share"
                :share-path="$wechat.getWechatMenuShareAppLink()"
                message="请复制下方链接，前往粘贴给好友"
                @share="handleShareSuccess"
    />
    <mobile-login :show.sync="showMobile"
                  @submit="handleLogin"
    />
    <draw-result-popup ref="draw"
                       :show.sync="showResult"
                       @success="handleDrawSuccess"
                       @close="handleClose"
    />
    <my-prize-popup :show.sync="showMyPrize"
                    :list="myPrizeList"
    />
    <draw-rule-popup :show.sync="showRule"
                     :rule="drawRule"
    />
    <draw-prize-popup :show.sync="showPrize"
                      :prize="prizeInfo"
    />
    <qr-code-popup :show.sync="showWechatContact"
                   :title="'如有疑问欢迎扫码<br>添加老师进行咨询'"
                   :qrcode="require('@/pages/2021/ChildrenDay/assets/img/wechat_contact.jpg')"
    />
    <contact-us-bar slot="tabbar"
                    top-color="#ffac68"
                    bottom-color="#ff4c29"
                    text-color="#ffffff"
                    @wechat="showWechatContact = true"
    />
    <ended-popup :show="showEndedPopup" />
  </bottom-bar-layout>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import ShareMask from '@/pages/2021/ChildrenDay/components/ShareMask';
  import MobileLogin from '@/pages/2021/ChildrenDay/components/MobileLogin';
  import DrawResultPopup from '@/pages/2021/ChildrenDay/components/DrawResultPopup';
  import MyPrizePopup from '@/pages/2021/ChildrenDay/components/MyPrizePopup';
  import WinningListNoticeBar from '@/pages/2021/ChildrenDay/components/WinningListNoticeBar';
  import DrawRulePopup from '@/pages/2021/ChildrenDay/components/DrawRulePopup';
  import DrawPrizePopup from '@/pages/2021/ChildrenDay/components/DrawPrizePopup';
  import ContactUsBar from '@/pages/2021/ChildrenDay/components/ContactUsBar';
  import QrCodePopup from '@/pages/2021/ChildrenDay/components/QrCodePopup';
  import EndedPopup from '@/pages/2021/ChildrenDay/components/EndedPopup';
  import event from '@/utils/bus';
  import {
    getChildrenDayInfo,
    updateChildrenDayDrawChance,
    getChildrenDayPrizeDrawList,
  } from '@/services/children-day-2021';
  import { loginRegisterWithMobile } from '@/services/app';
  import { decorator, before } from 'ym-reporter-vue';

  export default {
    name: 'ChildrenDay',
    components: {
      BottomBarLayout,
      ShareMask,
      MobileLogin,
      DrawResultPopup,
      MyPrizePopup,
      WinningListNoticeBar,
      DrawRulePopup,
      DrawPrizePopup,
      ContactUsBar,
      QrCodePopup,
      EndedPopup,
    },
    data() {
      return {
        loaded: false,
        showShareMask: false,
        render: null,
        user: null,
        drawCount: 3,
        prizeList: [],
        winningList: [],
        showMobile: false,
        showResult: false,
        drawResult: {},
        showMyPrize: false,
        myPrizeList: [],
        showRule: false,
        prizeInfo: {},
        showPrize: false,
        showWechatContact: false,
        showEndedPopup: false,
        drawRule: [],
        activityRule: [],
        project: null,
        scrollTimer: null,
        /* eslint-disable global-require */
        schoolList: [
          {
            id: 498,
            cover: require('@/pages/2021/ChildrenDay/assets/img/school_498.png'),
          },
          {
            id: 497,
            cover: require('@/pages/2021/ChildrenDay/assets/img/school_497.png'),
          },
          {
            id: 499,
            cover: require('@/pages/2021/ChildrenDay/assets/img/school_499.png'),
          },
        ],
        bookList: [
          {
            id: 3,
            cover: require('@/pages/2021/ChildrenDay/assets/img/discount_book_3.png'),
          },
          {
            id: 8,
            cover: require('@/pages/2021/ChildrenDay/assets/img/discount_book_8.png'),
          },
          {
            id: 35,
            cover: require('@/pages/2021/ChildrenDay/assets/img/discount_book_35.png'),
          },
          {
            id: 13,
            cover: require('@/pages/2021/ChildrenDay/assets/img/discount_book_13.png'),
          },
        ],
        /* eslint-enable global-require */
      };
    },
    computed: {
      drawState() {
        if (this.drawCount === 0) {
          return this.user.haveShare ? 'share' : 'disable';
        }
        return 'draw';
      },
    },
    methods: {
      async fetchData() {
        const data = await getChildrenDayInfo();
        if (data.render.status === 'ended') {
          setTimeout(() => {
            this.showEndedPopup = true;
          }, 0);
        }
        this.render = data.render;
        this.user = data.user;
        this.drawCount = data.user.drawCount;
        this.prizeList = data.prizeList;
        this.winningList = data.winningList;
        this.drawRule = data.prizeRule;
        this.activityRule = data.activityRule;
        this.project = data.project;
        this.loaded = true;
        this.$nextTick(() => {
          if (this.$refs.container) {
            this.scrollTimer = setInterval(() => {
              this.scrollStart();
            }, 50);
          }
        });
      },
      handleShare() {
        this.showShareMask = true;
      },
      async handleShareSuccess() {
        this.showShareMask = false;
        this.$refs.share.handleHiddenMask();
        if (!this.user.isLogin) return;
        if (!this.user.haveShare) return;
        if (this.drawCount !== 0) return;
        const data = await updateChildrenDayDrawChance();
        if (data.added) this.drawCount += 1;
      },
      shareSuccessListener() {
        event.$on('triggerShareAppMessage', () => {
          this.handleShareSuccess();
        });
        event.$on('triggerShareTimeline', () => {
          this.handleShareSuccess();
        });
      },
      @decorator(before(function () {
        if (this.drawState === 'disable') return;
        this.$reporter.report('MARKETING_2021CHILDRENDAY_LOTTERY_OPEN_CLICK');
      }))
      async handleDraw() {
        if (!this.user.isLogin) {
          this.showMobile = true;
          return;
        }
        if (this.drawCount === 0) {
          if (this.user.haveShare) this.handleShare();
          return;
        }
        this.showResult = true;
        await this.$refs.draw.handleDraw();
      },
      handleDrawSuccess(result) {
        this.drawCount = result.drawCount;
        this.user.haveShare = result.haveShare;
      },
      async handleLogin(e) {
        try {
          await loginRegisterWithMobile({
            mobile: e.mobile,
            sms_code: e.sms_code,
            sms_type: 'verify',
          });
          await this.fetchData();
          await this.handleDraw();
        } catch (err) {
          console.log(err);
        }
      },
      handleClose(share) {
        if (share) this.handleShare();
      },
      async handlePrize() {
        if (!this.user.isLogin) {
          this.showMobile = true;
          return;
        }
        const data = await getChildrenDayPrizeDrawList();
        this.myPrizeList = data.list;
        this.showMyPrize = true;
      },
      handleClickPrize(item) {
        this.prizeInfo = item;
        this.showPrize = true;
      },
      scrollStart() {
        const { container } = this.$refs;
        if (container.scrollLeft >= container.offsetWidth + container.offsetWidth * 0.01) {
          const header = this.prizeList.splice(0, 4);
          this.prizeList = this.prizeList.concat(header);
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 1;
        }
      },
      scrollStop() {
        if (this.scrollTimer) clearInterval(this.scrollTimer);
      },
    },
    created() {
      this.fetchData();
      this.shareSuccessListener();
    },
    beforeDestroy() {
      this.scrollStop();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-children-day {
    min-height: 100%;
    background: #17b4fb;
    &-header {
      width: 100%;
      height: 1002px;
    }
    &-draw {
      position: relative;
      top: -100px;
      width: 750px;
      height: 1430px;
      background: url('~@/pages/2021/ChildrenDay/assets/img/draw_bg.png');
      background-size: 100%;
      box-sizing: border-box;
      &-top {
        display: flex;
        justify-content: space-between;
        padding: 115px 30px 0;
        box-sizing: border-box;
        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 150px;
          height: 50px;
          border: 1px solid @color-white;
          border-radius: 25px;
          color: @color-white;
          font-size: @font-size-base;
        }
      }
      &-box {
        margin: 27px 41px 100px;
        width: 667px;
        height: 520px;
      }
      &-list {
        @list-width: calc(100% - 58px);
        width: @list-width;
        margin-left: 29px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: nowrap;
        overflow: scroll;
        .item {
          flex-shrink: 0;
          margin-right: 7px;
          width: 168px;
          height: 168px;
          border-radius: 13px;
          background: @color-white;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &:first-child {
            margin-left: 7px;
          }
          .cover {
            width: 133px;
            height: 94px;
            margin-bottom: 13px;
          }
          .text {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 126px;
            height: 30px;
            border-radius: 14px;
            background: #ff8022;
            color: @color-white;
            font-size: @font-size-extra-extra-small;
          }
        }
      }
      &-btn {
        margin-top: 75px;
        height: 134px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        padding: 0 30px;
        box-sizing: border-box;
        &-left {
          width: 178px;
          height: 123px;
          background: url('~@/pages/2021/ChildrenDay/assets/img/draw_btn_left.png');
          background-size: 100%;
          color: @color-white;
          font-size: 26px;
          text-align: center;
          padding-top: 10px;
          box-sizing: border-box;
        }
        &-center {
          width: 303px;
          height: 134px;
          &.draw {
            background-image: url('~@/pages/2021/ChildrenDay/assets/img/draw_btn_draw.gif');
          }
          &.share {
            background-image: url('~@/pages/2021/ChildrenDay/assets/img/draw_btn_share.png');
          }
          &.disable {
            background-image: url('~@/pages/2021/ChildrenDay/assets/img/draw_btn_disable.png');
          }
          background-size: 100%;
        }
        &-right {
          width: 178px;
          height: 123px;
          background: url('~@/pages/2021/ChildrenDay/assets/img/draw_btn_right.png');
          background-size: 100%;
          .content {
            width: 178px;
            height: 93px;
            display: flex;
            align-items: center;
            color: @color-white;
            .left {
              font-size: 30px;
              line-height: 36px;
              padding-left: 20px;
              padding-right: 8px;
            }
            .right {
              font-size: 80px;
              line-height: 80px;
            }
          }
        }
      }
      &-notice {
        position: absolute;
        left: 50%;
        bottom: 50px;
        margin-left: -280px;
      }
    }
    &-project {
      &-title {
        width: 740px;
        height: 243px;
        margin-left: 5px;
      }
      &-container {
        position: relative;
        margin-bottom: 133px;
        width: 690px;
        margin-left: 30px;
        padding: 20px 13px;
        background: linear-gradient(0deg, #12c9ea 0%, #0dffc3 100%);
        box-shadow: 0 3px 17px 0 rgba(92, 196, 115, 0.45);
        border-radius: 38px;
        box-sizing: border-box;
        &-top {
          position: absolute;
          left: 90px;
          top: -70px;
          width: 510px;
          height: 115px;
        }
        &-bottom {
          position: absolute;
          right: -30px;
          bottom: -10px;
          width: 113px;
          height: 205px;
        }
      }
      &-list {
        width: 665px;
        border-radius: 38px;
        background: #f3fceb;
        padding-top: 27px;
        box-sizing: border-box;
        &-item {
          width: 640px;
          height: 565px;
          position: relative;
          display: flex;
          flex-direction: column;
          background: url('~@/pages/2021/ChildrenDay/assets/img/project_bg.png');
          background-size: 100%;
          margin-left: 10px;
          padding-top: 62px;
          box-sizing: border-box;
          &-cover {
            width: 563px;
            height: 210px;
            margin-left: 39px;
          }
          &-age {
            width: 172px;
            height: 47px;
            background: url('~@/pages/2021/ChildrenDay/assets/img/project_age.png');
            background-size: 100%;
            position: absolute;
            top: 80px;
            left: 27px;
            color: @color-white;
            font-size: 25px;
            padding-top: 8px;
            padding-left: 16px;
            box-sizing: border-box;
          }
          &-hot {
            position: absolute;
            top: 195px;
            right: 22px;
            width: 107px;
            height: 98px;
          }
          &-title {
            width: 100%;
            height: 67px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #204688;
            font-size: 33px;
            font-weight: @font-weight-bold;
          }
          &-desc {
            width: 516px;
            height: 50px;
            background: #ffd11a;
            border-radius: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
            font-size: 25px;
            margin-bottom: 43px;
            margin-left: 60px;
          }
          &-bottom {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            padding: 0 56px;
            .left {
              display: flex;
              color: #ff1b41;
              font-size: 25px;
              font-weight: @font-weight-bold;
              line-height: 56px;
              span {
                color: #ff1b41;
                font-size: 45px;
                font-weight: @font-weight-bold;
                line-height: 44px;
                &:last-child {
                  margin-left: -10px;
                }
              }
            }
            .right {
              width: 225px;
              height: 72px;
              background: linear-gradient(-90deg, #ff4537, #ff7D27);
              border-radius: 36px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: @color-white;
              font-size: 30px;
              font-weight: @font-weight-bold;
            }
          }
        }
        &-more {
          height: 130px;
          border-bottom: 2px dashed #1a8cf7;
          margin-left: 21px;
          margin-right: 33px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &-top {
            position: relative;
            z-index: 1;
            color: #333;
            font-size: 32px;
            font-weight: @font-weight-bold;
            span {
              color: #ff4427;
            }
            &:before {
              position: absolute;
              bottom: 0;
              left: -30px;
              z-index: -1;
              content: '';
              width: 450px;
              height: 14px;
              border-radius: 6px;
              background: #ffe21e;
            }
          }
          &-bottom {
            color: #333;
            font-size: 32px;
            font-weight: @font-weight-bold;
            line-height: 47px;
          }
        }
        &-btn {
          position: relative;
          left: 50%;
          width: 540px;
          height: 142px;
          margin-top: 40px;
          margin-bottom: 40px;
          margin-left: -260px;
        }
      }
    }
    &-school {
      &-title {
        width: 740px;
        height: 243px;
        margin-left: 5px;
        margin-bottom: 8px;
      }
      &-list {
        margin-bottom: 137px;
        &-item {
          display: flex;
          margin: 0 42px 30px;
          &:last-child {
            margin-bottom: 0;
          }
          &-cover {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    &-discount {
      &-title {
        width: 716px;
        height: 190px;
        margin-left: 18px;
        margin-bottom: 8px;
      }
      &-container {
        width: 700px;
        margin-left: 25px;
        border-radius: 30px;
        padding: 20px 16px 32px;
        background-color: @color-white;
        box-sizing: border-box;
        &-card {
          position: relative;
          display: flex;
          width: 667px;
          height: 740px;
          background: url('~@/pages/2021/ChildrenDay/assets/img/year_card_bg.png');
          background-size: 100%;
          &-price {
            position: absolute;
            top: 580px;
            left: 32px;
            width: 594px;
            height: 113px;
            display: flex;
            padding-left: 36px;
            color: #333;
            font-size: 26px;
            box-sizing: border-box;
            line-height: 122px;
            span {
              color: #ff0505;
              font-size: 48px;
              font-weight: @font-weight-bold;
              line-height: 113px;
              &:last-child {
                margin-left: -10px;
              }
            }
          }
        }
        &-title {
          width: 100%;
          height: 190px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .top {
            color: #ff6b05;
            font-size: 44px;
            font-weight: @font-weight-bold;
          }
          .bottom {
            color: @color-text-light;
            font-size: 30px;
          }
        }
        &-list {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          margin-left: 11px;
          &-item {
            display: flex;
            width: 300px;
            height: 295px;
            margin-right: 44px;
            margin-bottom: 56px;
            &:nth-child(2n) {
              margin-right: 0;
            }
            &-cover {
              width: 100%;
              height: 100%;
            }
          }
        }
        &-entity-book {
          display: block;
          width: 643px;
          height: 202px;
          margin-bottom: 46px;
          background: url('~@/pages/2021/ChildrenDay/assets/img/entity_book.png');
          background-size: 100%;
          margin-left: 12px;
        }
        &-calendar {
          display: block;
          width: 643px;
          height: 202px;
          background: url('~@/pages/2021/ChildrenDay/assets/img/discount_calendar.png');
          background-size: 100%;
          margin-left: 12px;
        }
      }
    }
    &-rule {
      padding: 107px 30px 67px;
      &-title {
        text-align: center;
        position: relative;
        span {
          position: relative;
          z-index: 1;
          color: @color-white;
          font-size: 33px;
          font-weight: @font-weight-bold;
        }
        &:before {
          position: absolute;
          bottom: 0;
          left: 248px;
          z-index: 0;
          content: '';
          width: 195px;
          height: 13px;
          border-radius: 6px;
          background: #027ff7;
        }
      }
      &-list {
        width: 100%;
        border: 3px solid @color-white;
        border-radius: 30px;
        box-sizing: border-box;
        padding: 33px 19px 50px;
        margin-top: 33px;
        &-item {
          box-sizing: border-box;
          margin-bottom: 45px;
          color: @color-white;
          font-size: 25px;
          line-height: 37px;
          &:last-child {
            margin-bottom: 0;
          }
          span {
            display: inline-block;
            width: 32px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            background: #027ff7;
          }
        }
      }
    }
  }
</style>
